import Typography from 'app/components/Typography';

import { isActiveLabelAction } from 'app/helpers';

export const QtyTypography = ({ qty }: { qty: number }) => (
  <Typography variant="body-6" color={isActiveLabelAction(Number(qty)) ? 'success' : 'danger'}>
    {`${isActiveLabelAction(Number(qty)) ? '+' : ''}${String(qty ?? '')}`}
  </Typography>
);
